import { Badge, type BadgeVariant } from '../ui/Badge.tsx';

const STATUS_VARIANTS: Record<string, BadgeVariant> = {
  published: 'success',
  draft: 'default',
  cancelled: 'danger',
  completed: 'info',
};

const STATUS_LABELS: Record<string, string> = {
  published: 'Pubblicato',
  draft: 'Bozza',
  cancelled: 'Annullato',
  completed: 'Completato',
};

export function EventStatusBadge({ status }: { status: string }) {
  return (
    <Badge variant={STATUS_VARIANTS[status] ?? 'default'}>
      {STATUS_LABELS[status] ?? status}
    </Badge>
  );
}
